module.exports = __webpack_public_path__ + "img/1.6263e45a.png";